import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input-group publications-search-container mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "publicationsSearch"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-search",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
  ])
], -1)
const _hoisted_3 = { class: "table-responsive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicationsTable = _resolveComponent("PublicationsTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args))),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.options.params.s) = $event)),
        type: "text",
        class: "form-control publications-search-input mb-0",
        placeholder: "Search",
        "aria-label": "Search",
        "aria-describedby": "sotlSearch"
      }, null, 544), [
        [_vModelText, _ctx.options.params.s]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", {
        class: _normalizeClass(["table table-borderless", { loading: _ctx.isLoading }])
      }, [
        _createVNode(_component_PublicationsTable, {
          items: _ctx.items,
          onSortChange: _ctx.onTableSortChange
        }, null, 8, ["items", "onSortChange"])
      ], 2)
    ]),
    (_ctx.showLoadMoreBtn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickLoadBtn && _ctx.onClickLoadBtn(...args))),
          class: _normalizeClass([{ loading: _ctx.isLoading }, "w-100 fusion-button button-flat fusion-button-default-size button-default fusion-button-default button-1 fusion-button-default-span fusion-button-default-type"])
        }, "Load More", 2))
      : _createCommentVNode("", true)
  ], 64))
}